<template>
    <v-card
        class="mx-auto"
        max-width="500"
        outlined
        elevation="2"
    >
        <v-card-title class="justify-center">{{ $t('views.auth.verify_email.email_verification') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-center" v-if="emailVerifying">
            {{ $t('views.auth.verify_email.email_verification_processing') }}
            <v-progress-linear
                indeterminate
                color="primary"
                class="mb-5"
            ></v-progress-linear>
        </v-card-text>

        <v-card-text class="text-center" v-if="verificationCompleted">
            <v-alert
                dense
                outlined
                :type="success ? 'success' : 'error'"
                class="mb-0"
            >
                <template v-if="success">{{ $t('views.auth.verify_email.email_verified') }}</template>
                <template v-else>{{ $t('views.auth.verify_email.something_went_wrong') }}</template>
            </v-alert>
        </v-card-text>

        <v-card-actions v-if="verificationCompleted && ! success" class="d-flex justify-center">
            <v-btn
                @click="sendVerificationEmail"
                rounded
                text
                :loading="verificationEmailSending"
            >{{ $t('views.auth.verify_email.resend_verification_link') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import {Auth} from "../../modules/utils";

export default {
    name: "VerifyEmail",

    data() {
        return {
            emailVerifying: false,
            verificationCompleted: false,

            verificationEmailSending: false,

            success: false,
        };
    },

    methods: {
        sendVerificationEmail: function () {
            this.verificationEmailSending = true;

            this.$store.dispatch('sendVerificationEmail').then(response => {
                if(response.status !== 202) {
                    this.$store.commit(
                        "showSnackbarError",
                        this.$t('views.auth.verify_email.resend_verification_link_failed')
                    );
                    return;
                }

                this.$router.push({name: 'confirm_email'}).catch(() => {});
            })
                .catch(() => {})
                .then(() => {
                    this.verificationEmailSending = false;
                });
        },
    },

    created() {
        this.emailVerifying = true;

        this.$store.dispatch('verifyEmail', {
            id: this.$route.params.id,
            hash: this.$route.params.hash,
            params: {
                expires: this.$route.query.expires,
                signature: this.$route.query.signature,
            }
        }).then(response => {
            if(response.status !== 200) {
                this.success = false;
                this.$store.commit(
                    "showSnackbarError",
                    this.$t('views.auth.verify_email.email_verification_failed')
                );
                return;
            }

            // noinspection JSUnresolvedVariable
            Auth.verify(response.data.verified);
            this.success = true;
            let redirect = this.$route.query.redirect;
            this.$router.push(redirect ? {path: redirect} : {name: 'orders'}).catch(() => {});
        }).catch(() => {
            this.success = false;
        }).then(() => {
            this.emailVerifying = false;
            this.verificationCompleted = true;
        });
    },
}
</script>

<style scoped>

</style>
